/* eslint-disable @typescript-eslint/no-explicit-any */
import AuthorCard from '@apps/components/AuthorCard';
import avatarPlaceholder from '@stack/assets/images/avatar_placeholder.jpeg';

import { AuthorsListingProps } from './props';
import { ContentWrapper, InnerContentWrapper, SectionWrapper } from './styles';

/**
 * ===========================
 * MAIN
 * ===========================
 */
export const AuthorListing: React.FC<AuthorsListingProps> = (props) => {
  const { data, webView = false, loading } = props;
  // ======================= HOOKS

  // ======================= STATE

  // ======================= API

  // ======================= EVENTS

  // ======================= VARIABLES

  // ======================= RENDER FUNCTIONS
  if (loading)
    return (
      <SectionWrapper>
        <ContentWrapper>
          {Array.from({ length: 12 }).map((rd: any, index) => {
            return (
              <InnerContentWrapper
                className="list-item custom-list-border"
                key={index}
              >
                <AuthorCard
                  tabletImagePosition="top"
                  simpleMobileView={true}
                  loading={loading}
                  webView={webView}
                  imageProps={{
                    src: '',
                    width: 173,
                    height: 173,
                    alt: '',
                  }}
                />
              </InnerContentWrapper>
            );
          })}
        </ContentWrapper>
      </SectionWrapper>
    );
  // ======================= VIEWS
  return (
    <SectionWrapper>
      {data && (
        <ContentWrapper
          style={{
            minHeight: loading ? '70vh' : 'unset',
          }}
        >
          {data.map((e: any, index: number) => {
            const authorData = {
              name: e?.name,
              role: e?.role,
              username: e?.username,
              social: e?.social,
              totalPost: e?.total_post,
            };
            return (
              <InnerContentWrapper
                className="list-item custom-list-border"
                key={index}
              >
                <AuthorCard
                  imageProps={{
                    src: e?.image || avatarPlaceholder?.src,
                    width: 173,
                    height: 173,
                    alt: e?.name,
                    fallbackSrc: avatarPlaceholder?.src,
                  }}
                  imagePosition="top"
                  tabletImagePosition="top"
                  mobileImagePostion="top"
                  maxImageWidth={'100%'}
                  loading={loading}
                  webView={webView}
                  data={authorData}
                />
              </InnerContentWrapper>
            );
          })}
        </ContentWrapper>
      )}
    </SectionWrapper>
  );
};

/**
 * ===========================
 * EXPORTS
 * ===========================
 */
export default AuthorListing;
